import { Text } from "@/src/components/ui/BrandText";
import { border, surface, text as uiText } from "@/src/theme/tokens";
import { collection, limit, onSnapshot, query, where } from "firebase/firestore";
import React from "react";
import { ActivityIndicator, View } from "react-native";

import { db } from "../lib/firebase";

const CARD = surface.primary;
const BORDER = border.subtle;
const MUTED = uiText.muted;

export function GroupModerationQueue({ groupId }: { groupId: string }) {
  const [items, setItems] = React.useState<{ id: string; reason?: string; targetId?: string }[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!groupId) return;
    const reportsQuery = query(
      collection(db, "groupModerationQueue"),
      where("groupId", "==", groupId),
      where("assignedTo", "==", "group_admin"),
      where("severity", "==", "normal"),
      where("status", "==", "open"),
      limit(30)
    );
    return onSnapshot(
      reportsQuery,
      (snap) => {
        setItems(snap.docs.map((item) => ({ id: item.id, ...(item.data() as any) })));
        setLoading(false);
      },
      () => {
        setItems([]);
        setLoading(false);
      }
    );
  }, [groupId]);

  if (loading) return <ActivityIndicator color={uiText.brand} />;
  if (!items.length) return null;

  return (
    <View style={{ marginBottom: 12, padding: 12, borderRadius: 16, backgroundColor: CARD, borderWidth: 1, borderColor: BORDER }}>
      <Text style={{ color: uiText.primary, fontWeight: "900" }}>Signalements du groupe</Text>
      <Text style={{ color: MUTED, marginTop: 4 }}>Seuls les signalements ordinaires de ce groupe sont visibles.</Text>
      {items.map((item) => (
        <View key={item.id} style={{ marginTop: 10, paddingTop: 10, borderTopWidth: 1, borderTopColor: BORDER }}>
          <Text style={{ color: uiText.primary, fontWeight: "800" }}>{item.reason ?? "Signalement"}</Text>
          <Text style={{ color: MUTED, marginTop: 3 }}>Publication : {item.targetId}</Text>
        </View>
      ))}
    </View>
  );
}
